/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const bubble = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.46 1a6.515 6.515 0 0 0-5.705 3.352 6.528 6.528 0 0 0 .162 6.62L1 15l4.025-1.918a6.524 6.524 0 0 0 9.726-3.76 6.538 6.538 0 0 0-3.377-7.64A6.524 6.524 0 0 0 8.461 1v0Z"
    />
  </svg>
)
export default bubble
